/* LNC winkelmand-flyout fase 1 (oktober 2026)
   - zet kop (aantal) en voordeelbalk bij na elke wijziging in de mand
   - cadeau toevoegen met de knop "Toevoegen" (eigenschap _cadeau) en weghalen als de mand onder de drempel zakt
   - aanbiedblok licht kort op, schaduw onder de kop bij scrollen, pijltjes bij Aanvullen
   - incl./excl. btw volgens de keuze van de bezoeker (localStorage showVat, zoals vat-check.js) */
(function () {
  if (window.__lncCart) return;
  window.__lncCart = true;

  var removing = false;
  var scheduled = false;

  function drawer() { return document.querySelector('cart-drawer'); }

  function showVat() {
    try {
      var v = localStorage.getItem('showVat');
      if (v !== null) return JSON.parse(v);
    } catch (e) {}
    return !document.querySelector('[data-vat-switch-default-excl-vat]');
  }

  function applyVat(root) {
    var incl = showVat();
    root.querySelectorAll('[data-price-toggle-vat]').forEach(function (c) {
      c.querySelectorAll('[data-price-vat-included]').forEach(function (e) { e.toggleAttribute('hidden', !incl); });
      c.querySelectorAll('[data-price-vat-excluded]').forEach(function (e) { e.toggleAttribute('hidden', incl); });
    });
  }

  function fitLabels(root) {
    root.querySelectorAll('[data-lnc-labels]').forEach(function (el) {
      el.classList.remove('is-tight');
      if (el.scrollWidth > el.clientWidth + 1) el.classList.add('is-tight');
    });
  }

  function sync() {
    scheduled = false;
    var d = drawer();
    if (!d) return;

    // Voordeelbalk bovenaan bijwerken vanuit de bron in het middendeel
    var src = d.querySelector('template[data-lnc-bar-src]');
    var slot = d.querySelector('[data-lnc-bar-slot]');
    if (slot) {
      var html = src ? src.innerHTML : '';
      if (slot.getAttribute('data-lnc-html') !== String(html.length) + ':' + html.slice(0, 200) + html.slice(-200)) {
        slot.innerHTML = html;
        slot.setAttribute('data-lnc-html', String(html.length) + ':' + html.slice(0, 200) + html.slice(-200));
      }
    }

    // Aantal in de kop
    var sig = d.querySelector('[data-lnc-count]');
    var label = d.querySelector('[data-lnc-count-label]');
    if (label) {
      var n = sig ? parseInt(sig.getAttribute('data-lnc-count'), 10) || 0 : 0;
      var txt = n > 0 ? ' (' + n + ')' : '';
      if (label.textContent !== txt) label.textContent = txt;
    }

    // Cadeau weghalen als de mand onder de drempel zakt of de actie uit staat
    var rm = d.querySelector('[data-lnc-gift-remove]');
    if (rm && !removing) {
      var items = d.querySelector('cart-items');
      if (items && typeof items.updateQuantity === 'function') {
        removing = true;
        items.updateQuantity(rm.getAttribute('data-lnc-gift-remove'), 0);
        setTimeout(function () { removing = false; }, 2500);
      }
    }

    // Aanbiedblok: kort oplichten, alleen de eerste keer na het halen van de drempel
    var reached = sig && sig.getAttribute('data-lnc-gift-reached') === 'true';
    try { if (!reached) sessionStorage.removeItem('lncOfferFlashed'); } catch (e) {}
    var offer = d.querySelector('[data-lnc-offer-block]');
    if (offer && !offer.hasAttribute('data-lnc-seen')) {
      offer.setAttribute('data-lnc-seen', '');
      var flashed = false;
      try { flashed = sessionStorage.getItem('lncOfferFlashed') === '1'; } catch (e) {}
      if (!flashed) {
        offer.classList.add('is-flash');
        try { sessionStorage.setItem('lncOfferFlashed', '1'); } catch (e) {}
        setTimeout(function () { offer.classList.remove('is-flash'); }, 3000);
      }
    }

    // Pijltjes Aanvullen
    var row = d.querySelector('[data-lnc-reco-row]');
    if (row) updateArrows(d, row);

    applyVat(d);
    fitLabels(d);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function updateArrows(d, row) {
    var prev = d.querySelector('[data-lnc-reco-scroll="-1"]');
    var next = d.querySelector('[data-lnc-reco-scroll="1"]');
    var max = row.scrollWidth - row.clientWidth;
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max - 2;
    var nav = d.querySelector('.lnc-reco__nav');
    if (nav) nav.style.visibility = max > 2 ? 'visible' : 'hidden';
  }

  function addGift(btn) {
    var d = drawer();
    var variantId = btn.getAttribute('data-variant-id');
    if (!d || !variantId) return;
    btn.setAttribute('disabled', '');
    btn.classList.add('loading');
    var sections = typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.section; }) : [];
    var cfg = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    cfg.body = JSON.stringify({
      items: [{ id: variantId, quantity: 1, properties: { _cadeau: '1' } }],
      sections: sections,
      sections_url: window.location.pathname
    });
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.sections && typeof d.renderContents === 'function') {
          d.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function (e) {
        console.error(e);
        btn.removeAttribute('disabled');
        btn.classList.remove('loading');
      });
  }

  // Samengevoegde regel (Shopify splitste dezelfde variant over meerdere regels).
  // Plus en min zetten het nieuwe totaal op de eerste regel en de andere regels op 0.
  // Borduurregels die bij deze jas horen krijgen hetzelfde aantal.
  var mergeTimer = null;
  function updateMerged(input) {
    var items = input.closest('cart-items');
    if (!items) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    var keys = (input.getAttribute('data-lnc-merge') || '').split(',').filter(Boolean);
    var master = input.getAttribute('data-lnc-master') || '';
    if (typeof items.enableLoading === 'function') items.enableLoading(input.getAttribute('data-index'));
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var updateUrl = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        keys.forEach(function (k, i) { updates[k] = i === 0 ? qty : 0; });
        if (master) {
          var seen = {};
          cart.items.forEach(function (it) {
            if (it.properties && it.properties._linkedSKU === master) {
              var sig = it.variant_id + JSON.stringify(it.properties);
              updates[it.key] = seen[sig] ? 0 : qty;
              seen[sig] = true;
            }
          });
        }
        var sections = items.getSectionsToRender();
        var cfg = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        cfg.body = JSON.stringify({ updates: updates, sections: sections.map(function (s) { return s.section; }), sections_url: window.location.pathname });
        return fetch(updateUrl, cfg).then(function (r) { return r.json(); }).then(function (state) {
          if (!state || !state.sections) throw new Error('Geen sections in antwoord');
          items.classList.toggle('cart-is-empty', state.item_count === 0);
          sections.forEach(function (section) {
            var host = document.getElementById(section.id);
            if (!host) return;
            var target = host.querySelector(section.selector) || host;
            target.innerHTML = items.getSectionInnerHTML(state.sections[section.section], section.selector);
          });
          if (typeof items.disableLoading === 'function') items.disableLoading();
          var d = drawer();
          if (d && typeof d.initRecommendationsButtons === 'function') d.initRecommendationsButtons();
        });
      })
      .catch(function (err) {
        console.error(err);
        window.location.reload();
      });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-lnc-merge]')) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    clearTimeout(mergeTimer);
    mergeTimer = setTimeout(function () { updateMerged(t); }, 300);
  }, true);

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-lnc-gift-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      addGift(add);
      return;
    }
    var arrow = e.target.closest('[data-lnc-reco-scroll]');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      var row = drawer() && drawer().querySelector('[data-lnc-reco-row]');
      if (row) row.scrollBy({ left: parseInt(arrow.getAttribute('data-lnc-reco-scroll'), 10) * 186, behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var d = drawer();
    if (!d) return;
    if (t.matches('[data-lnc-body]')) {
      var top = d.querySelector('[data-lnc-top]');
      if (top) top.classList.toggle('is-scrolled', t.scrollTop > 2);
    }
    if (t.matches('[data-lnc-reco-row]')) updateArrows(d, t);
  }, true);

  window.addEventListener('resize', schedule);
  window.addEventListener('storage', schedule);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'showVat') setTimeout(schedule, 0);
  });

  function start() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
